import { render, staticRenderFns } from "./v-supply-select2.vue?vue&type=template&id=f6e340e8&scoped=true&"
import script from "./v-supply-select2.vue?vue&type=script&lang=js&"
export * from "./v-supply-select2.vue?vue&type=script&lang=js&"
import style0 from "./v-supply-select2.vue?vue&type=style&index=0&id=f6e340e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e340e8",
  null
  
)

export default component.exports